export const migrateToV2 = (state)=>{
    // There are no changes in v2 schema, but the bump is needed to update configuration schema
    // on staging and production servers. There was a bug previously, which caused
    // all schemas stored in DB to be se to `{}`. But Metalworks schema does not match
    // the `{}` and deployment fails when schemas of the same version don't match.
    return state;
};

//# sourceMappingURL=v2.js.map